const Dot: React.FC = () => <p>•</p>

export default Dot
